import React from 'react';

import type { TagEntity } from '@schibsted/frapi-schema';

import { makeTagTitle } from '../helpers.js';

type TagProps = {
  tag: TagEntity;
  noBorder?: boolean;
  regular?: boolean;
};

const Tag: React.FC<TagProps> = ({ tag, noBorder, regular }) => {
  const classNames = [
    regular ? 'regular' : '',
    noBorder ? 'text-tag' : 'regular-tag',
  ].join(' ');

  return (
    <a href={`/tag/${tag.slug}`} className={classNames}>
      {makeTagTitle(tag.title)}
    </a>
  );
};

export default Tag;
